import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW6600Model } from './kymw6600.model';
import { GetIndicationListService } from './api-services/get-indication-list.service';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { CodeComboBoxComponent } from '../../../commons/kymw02/combo-box/code-combo-box/code-combo-box.component';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { OrderCodeTextInputComponent } from '../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';

/**
 * 特別指示書画面を管理するクラス
 *
 * @export KYMW6600Component
 * @class KYMW6600Component
 */
@Component({
  selector: 'app-kymw6600',
  templateUrl: 'kymw6600.component.html',
  styleUrls: ['kymw6600.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW6600Component extends PlessViewHelperSub implements OnInit {

  @ViewChild('txti_OrderCode', { static: true }) public txti_OrderCode: OrderCodeTextInputComponent;
  @ViewChild('cmb_SpeciallyIndicationDiv', { static: true }) cmb_SpeciallyIndicationDiv: CodeComboBoxComponent;

  // 親画面からの連携値
  param: any;

  kymw6600Model: KYMW6600Model = new KYMW6600Model();

  /**
   *Creates an instance of KYMW6600Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {GetIndicationListService} getIndicationListService
   * @param {FileDownloadConfirmService} fileDownloadConfirmService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW6600Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private getIndicationListService: GetIndicationListService,
    private fileDownloadConfirmService: FileDownloadConfirmService,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW6600Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW6600';
    this.initKYMW6600();
  }

  /**
   * 出力ボタンを押下した時に呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventListOut_CLICKHandler(): void {
    if (!this.inputCheck()) {                                                   // 入力チェックエラーの場合
      // 処理復帰
      return;
    }

    const vo = {
      // 指示区分
      indicationDiv: '',
      // 受注コード
      orderCode: '',
      // 部門
      classCode: '',
      // 媒体
      mediumType: '',
      // バイヤーコード
      buyerCode: '',
    };
    vo.indicationDiv = this.cmb_SpeciallyIndicationDiv.selectedCodeValue;
    vo.orderCode = this.kymw6600Model.orderCode;
    vo.classCode = PlessViewUtilsSub.nullToBlank(this.kymw6600Model.classCode);
    vo.mediumType = PlessViewUtilsSub.nullToBlank(this.kymw6600Model.mediumType);
    vo.buyerCode = PlessViewUtilsSub.nullToBlank(this.kymw6600Model.buyerCode);

    // API呼び出し
    this.getIndicationListService.execute(this.kymw6600Model, vo, (data: any) => {
      // ファイル名の設定
      const fileName = '特別指示書_' + this.cmb_SpeciallyIndicationDiv.selectedCodeValue + '_'
        + PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss') + '.xls';
      this.fileDownloadConfirmService.show(data.FileName, fileName);
    });
  }

  /**
   *  画面情報の初期化
   *
   */
  private initKYMW6600(): void {
    // 受注コードをクリアに連動して、配達企画回（翌週）がクリア、媒体が再作成される。
    this.kymw6600Model.orderCode = '';
  }

  /**
   * メニュー「最新の情報に更新」押下時の処理
   *
   */
  private reloadKYMW6600(): void {
    this.initKYMW6600();
  }

  /**
   * 入力チェック
   *
   * @private
   * @returns {boolean} true:正常、false:異常
   * @memberof KYMW6600Component
   */
  private inputCheck(): boolean {
    // 指示書区分必須チェック
    if (this.cmb_SpeciallyIndicationDiv.selectedIndex < 0) {
      this.dialogService.openAlertGetMessage('E0148', ['指示書区分']);
      return false;
    }
    // 受注コード必須チェック
    if (PlessViewUtilsSub.isEmpty(this.kymw6600Model.orderCode)) {
      this.dialogService.openAlertGetMessage('E0110', ['受注コード']);
      return false;
    }
    // 受注コード存在チェック
    if (PlessViewUtilsSub.isEmpty(this.txti_OrderCode.selectedCatalogID)) {
      this.dialogService.openAlertGetMessage('E0122', ['受注コード']);
      return false;
    }
    // チェック結果(true:正常)を返却
    return true;
  }
}
